module.exports = __webpack_public_path__ + "img/logo-desktop.14c751e.svg";